import { Image, Progress, Rate } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import './index.scss';

import {
  AgentContent,
  AgentContentWrapper,
  AgentInfo,
  AgentInfoMobile,
  AgentList,
  ChatMessageAgentWrapper,
  ChatMessageCustomerWrapper,
  ChatMessageEvent,
  ContentImage,
  ContentVideo,
  CustomerContent,
  CustomerContentFooter,
  CustomerContentWrapper,
  CustomerInfo,
  CustomerMessageWarpper,
  EvaluationDiv,
  EvaluationLine,
  FileUploading,
  LeftWrapper,
  LikeButContainer,
  ListItem,
  MessageBody,
  MessageQuote,
  RightWrapper,
  UploadContainer,
} from './styled';
// 解析markdown内容
import ReactMarkdown from 'react-markdown';
// 客户图标
import customer from '../../assets/user.svg';
// 上传的关闭按钮
import close from '../../assets/closeIcon2.svg';
import { messageDateType, messageRole } from '../../constant';
const MsgReadedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM11.5811 5.92285C11.7773 5.72888 12.0939 5.73078 12.2881 5.92676C12.4821 6.12288 12.481 6.43952 12.2852 6.63379L7.3877 11.4824C7.29289 11.5763 7.16368 11.6282 7.03027 11.627C6.89708 11.6255 6.7696 11.5711 6.67676 11.4756L3.64062 8.34766C3.44889 8.14947 3.4544 7.83276 3.65234 7.64062C3.85053 7.44889 4.16724 7.4544 4.35938 7.65234L7.04199 10.417L11.5811 5.92285Z"
      fill="#00B900"
    />
  </svg>
);
const MsgReadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7.5" stroke="#999999" />
  </svg>
);
const agent = (color = '#3463FC') => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1199_12716)">
      <circle cx="10" cy="10" r="10" fill="white" />
      <path
        d="M10 0C15.523 0 20 4.47696 20 10C20 15.523 15.523 20 10 20C4.47696 20 0 15.523 0 10C0 4.47696 4.47696 0 10 0ZM9.97783 4.41261C7.28217 4.41261 5.08956 6.64478 5.08956 9.40826C5.08956 9.43087 5.0913 9.45304 5.09391 9.47522C5.08957 9.51087 5.08956 9.54739 5.08956 9.58391V10.9874C5.05217 11.7222 5.64348 12.3478 6.41435 12.3887H6.74565C7.51783 12.3483 8.11 11.7213 8.07174 10.9857V9.58348C8.10956 8.8487 7.51826 8.22261 6.74739 8.1813H6.41565C6.36844 8.18125 6.32126 8.18386 6.27435 8.18913C6.62435 6.91348 7.67 5.91696 9.00913 5.58304C11.0552 5.07304 13.1474 6.23957 13.683 8.18913C13.6358 8.18383 13.5884 8.18122 13.5409 8.1813H13.2096C12.4378 8.2213 11.8457 8.84826 11.8835 9.58348V10.9878C11.8452 11.723 12.4378 12.3504 13.2096 12.3904H13.4539C13.0638 13.0909 12.4534 13.6431 11.7174 13.9613C11.6277 13.8689 11.5146 13.8025 11.3903 13.7691C11.2659 13.7356 11.1348 13.7364 11.0109 13.7713L10.05 14.0435C9.64 14.187 9.41348 14.6061 9.52826 15.0078L9.53826 15.05C9.63652 15.4287 10.0383 15.6604 10.4365 15.5665L11.397 15.2943C11.7057 15.1952 11.9217 14.9291 11.9448 14.6204C13.0587 14.1296 13.9152 13.2287 14.3152 12.1243C14.4883 11.9897 14.628 11.8169 14.7235 11.6195C14.8191 11.4221 14.8678 11.2054 14.8661 10.9861V9.58348L14.8617 9.47478C14.8648 9.45304 14.8661 9.43043 14.8661 9.40826C14.8661 6.64478 12.6735 4.41261 9.97783 4.41261Z"
        fill="#3463FC"
      />
      <g clipPath="url(#clip1_1199_12716)">
        <circle cx="10" cy="10" r="10" fill={color} />
        <g clipPath="url(#clip2_1199_12716)">
          <path
            d="M16.1033 8.30923C15.8092 5.14746 13.2357 2.64746 10.0004 2.64746C6.76511 2.64746 4.11805 5.14746 3.89746 8.30923C3.16217 8.60334 2.64746 9.41217 2.64746 10.2945V11.6916C2.64746 12.868 3.60334 13.8239 4.77981 13.8239H5.58864C5.88276 13.8239 6.10334 13.6033 6.10334 13.3092V8.67687C6.10334 8.38276 5.88276 8.16217 5.58864 8.16217H4.92687C5.29452 5.66217 7.35334 3.7504 10.0004 3.7504C12.5739 3.7504 14.7063 5.66217 15.0739 8.16217H14.4122C14.118 8.16217 13.8975 8.38276 13.8975 8.67687V13.2357C13.8975 13.5298 14.118 13.7504 14.4122 13.7504H14.6328C14.4122 15.0004 13.4563 15.7357 11.618 15.8828C11.471 15.6622 11.1769 15.5151 10.8828 15.5151H9.85334C9.33864 15.5151 8.97099 15.8828 8.97099 16.3975C8.97099 16.9122 9.33864 17.2798 9.85334 17.2798H10.8828C11.1769 17.2798 11.3975 17.2063 11.5445 16.9857C14.0445 16.8386 15.4416 15.7357 15.6622 13.6769C16.618 13.5298 17.3533 12.6475 17.3533 11.618V10.221C17.3533 9.41217 16.8386 8.60334 16.1033 8.30923ZM5.07393 9.41217V12.5004C5.07393 12.6475 5.0004 12.721 4.85334 12.721H4.77981C4.19158 12.721 3.7504 12.2798 3.7504 11.6916V10.2945C3.7504 9.70628 4.19158 9.26511 4.77981 9.26511H4.85334C5.0004 9.19158 5.07393 9.33864 5.07393 9.41217ZM16.3239 11.6916C16.3239 12.2798 15.8828 12.721 15.2945 12.721H15.1475C15.0004 12.721 14.9269 12.6475 14.9269 12.5004V9.41217C14.9269 9.26511 15.0004 9.19158 15.1475 9.19158H15.221C15.8092 9.19158 16.2504 9.63276 16.2504 10.221V11.6916H16.3239Z"
            fill="white"
          />
          <path
            d="M10.0007 13.8963C9.04481 13.8963 8.23598 13.5286 7.42716 12.7933C7.20657 12.5727 7.20657 12.2786 7.42716 12.058C7.64775 11.8374 7.94187 11.8374 8.16245 12.058C9.33892 13.161 10.736 13.161 11.8389 12.058C12.0595 11.8374 12.3536 11.8374 12.5742 12.058C12.7948 12.2786 12.7948 12.5727 12.5742 12.7933C11.7654 13.5286 10.9566 13.8963 10.0007 13.8963Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1199_12716">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip1_1199_12716">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip2_1199_12716">
        <rect width="14.7059" height="14.7059" fill="white" transform="translate(2.64746 2.64746)" />
      </clipPath>
    </defs>
  </svg>
);

const ChatMessageAmazon = ({
  device,
  chatConfig,
  messageList,
  handleClickMessage,
  handleClickRate,
  uploadCancelToken,
  updateMessageScrollBarInfo,
  handleClickLikeBut,
}) => {
  const ButtonArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 12 13" fill="none">
      <path
        d="M11 6.50003C11 6.45003 11 6.35002 10.95 6.30002C10.9 6.05002 10.8 5.85003 10.6 5.70003L7.75 3.15002C7.55 2.95002 7.25 3.00002 7.1 3.20002C6.9 3.40002 6.95 3.70003 7.15 3.85003L9.55 6.00003H2.5C2.25 6.00003 2 6.20003 2 6.50003C2 6.80002 2.2 7.00003 2.5 7.00003H9.55L7.15 9.15003C6.95 9.35003 6.95 9.65002 7.1 9.80002C7.2 9.90002 7.3 9.95003 7.45 9.95003C7.55 9.95003 7.7 9.90003 7.75 9.85003L10.6 7.30002C10.8 7.15002 10.9 6.90002 10.95 6.70002C11 6.65002 11 6.55002 11 6.50003Z"
        fill="currentColor"
      />
    </svg>
  );
  const AudioIcon = () => (
    <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.4 9.1C1.4 9.4866 1.0866 9.8 0.7 9.8C0.313401 9.8 0 9.4866 0 9.1V4.9C0 4.5134 0.313401 4.2 0.7 4.2C1.0866 4.2 1.4 4.5134 1.4 4.9V9.1ZM18.2 4.9C18.2 4.5134 17.8866 4.2 17.5 4.2C17.1134 4.2 16.8 4.5134 16.8 4.9V9.1C16.8 9.4866 17.1134 9.8 17.5 9.8C17.8866 9.8 18.2 9.4866 18.2 9.1V4.9ZM5.6 3.5C5.6 3.1134 5.2866 2.8 4.9 2.8C4.5134 2.8 4.2 3.1134 4.2 3.5V10.5C4.2 10.8866 4.5134 11.2 4.9 11.2C5.2866 11.2 5.6 10.8866 5.6 10.5V3.5ZM14 3.5C14 3.1134 13.6866 2.8 13.3 2.8C12.9134 2.8 12.6 3.1134 12.6 3.5V10.5C12.6 10.8866 12.9134 11.2 13.3 11.2C13.6866 11.2 14 10.8866 14 10.5V3.5ZM9.8 0.7C9.8 0.313401 9.4866 0 9.1 0C8.7134 0 8.4 0.313401 8.4 0.7V13.3C8.4 13.6866 8.7134 14 9.1 14C9.4866 14 9.8 13.6866 9.8 13.3V0.7Z"
        fill={chatConfig.chatThemeColor}
      />
    </svg>
  );
  // 消息bodyRef
  const messageBodyRef = useRef(null);
  let [showGif, setShowGif] = useState(false);

  // const linkAttributePlugin = [[remarkLinkAttributes, { target: '_blank' }]];
  const renderers = {
    link: ({ href, children }) => (
      <a
        href={href}
        target={device === 'mobile' ? '_self' : '_blank'}
        rel="noopener noreferrer"
        onClick={() => {
          let obj = {
            from: 'connectNow',
            action: 'click',
            url: href,
            name: children,
          };
          window.postMessage(JSON.stringify(obj));
        }}
      >
        {children}
      </a>
    ),
  };

  // Antd Image 预览层默认 z-index 较低：当聊天容器 z-index 很高(例如 99991)时会被盖住。
  // 这里把预览层挂到 body，并把 z-index 调到比聊天容器更高。
  const previewZIndex = (() => {
    const base = Number(chatConfig?.zIndex);
    return Number.isFinite(base) && base > 0 ? base + 1000 : 2000;
  })();
  const imagePreview = { getContainer: () => document.body, zIndex: previewZIndex };

  // 处理页面销毁时，关闭资源
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      // 遍历所有被观察的元素
      for (const entry of entries) {
        updateMessageScrollBarInfo();
      }
    });

    // 要观察变化的元素
    const targetElement = messageBodyRef.current;
    // 开始观察目标元素的尺寸变化
    observer.observe(targetElement);
  }, []);
  useEffect(() => {
    console.log('queueCount>>messageList: ', messageList);
  }, [messageList]);
  /**
   * 点击赞图标
   * @param item 消息数据
   * @param type 消息类型，0点击正赞，1点击倒赞
   */
  const handleClickLikeIcon = (item, type) => {
    handleClickLikeBut(item, type);
  };

  /**
   * 识别Message对象中的Type返回相应的标签
   * @param message 消息对象
   * @param index 消息下标
   * @returns {Element} 对应标签内容
   */
  const messageTypeAnalyzer = (message, index) => {
    if (message) {
      // 如果是回话事件消息
      if (message.dataType === messageDateType.EVENT) {
        return eventMessage(message, index);
      }
      // 如果是聊天内容消息
      if (message.dataType === messageDateType.MESSAGE) {
        // 知识库消息
        if (message.role === messageRole.KNOWLEDGE) {
          return knowledgeMessage(message, index);
        }
        // connect的坐席消息
        else if (message.role === messageRole.AGENT) {
          return agentMessage(message, index);
        }
        // 客户
        else if (message.role === messageRole.CUSTOMER) {
          // // 同步附件上传列表中的上传进度
          // const upload = uploadProgress.find(upload => upload.fileName === message.fileName);
          // // 如果找到匹配的fileName，则更新message对象的uploadProgress
          // if (upload) {
          //   message.uploadProgress = upload.progress;
          // }
          return customerMessage(message, index);
        }
      }
      // 如果是满意度评价
      if (message.dataType === messageDateType.EVALUATION) {
        return evaluationMessage(message, index);
      }
      // 如果是分割线
      if (message.dataType === messageDateType.DIVIDER) {
        return dividerMessage(message, index);
      }
    } else {
      return knowledgeMessage(message, index);
    }
  };

  const handleClickButton = (item, index) => {
    handleClickMessage(item, index);
  };

  const handleCancelUpload = (message) => {
    if (uploadCancelToken) {
      uploadCancelToken.cancel('用户取消上传');
    }
  };

  /**
   * 回话消息
   * @param message
   * @param index
   * @returns {Element}
   */
  function eventMessage(message, index) {
    return (
      <ChatMessageEvent key={index} $device={device} $chatservicecolor={chatConfig.chatServiceColor}>
        <span>{message.content}</span>
      </ChatMessageEvent>
    );
  }

  /**
   * 知识库消息
   * @param message
   * @param index
   */
  function knowledgeMessage(message, index) {
    return (
      <ChatMessageAgentWrapper key={index}>
        {message ? (
          <CSSTransition in={true} appear={true} timeout={3000} classNames="message">
            <div>
              <AgentInfo $device={device}>
                {chatConfig.chatRobotIcon ? (
                  <img style={{ borderRadius: 50 }} src={chatConfig.chatRobotIcon} alt="" />
                ) : (
                  agent(chatConfig.chatThemeColor)
                )}
                {/*{agent(chatConfig.chatThemeColor)}*/}
                <span>{message.displayName}</span>
              </AgentInfo>
              <AgentContentWrapper $device={device}>
                {message.contentType === 'image' ? (
                  <ContentImage
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <Image src={message.content} preview={imagePreview} />
                  </ContentImage>
                ) : message.contentType === 'video' ? (
                  <ContentVideo
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <video
                      src={message.content}
                      controls
                      style={{ width: '100%' }}
                      controlsList="nodownload"
                      playsInline
                    ></video>
                  </ContentVideo>
                ) : message.contentType === 'link' ? (
                  <AgentContent
                    $agentFontColor={chatConfig.agentFontColor}
                    $device={device}
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <a href={message.content}>{message.fileName}</a>
                  </AgentContent>
                ) : (
                  <AgentContent
                    $agentFontColor={chatConfig.agentFontColor}
                    $device={device}
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown>
                    {message.isShowLikeBut ? (
                      <LikeButContainer>
                        <span
                          onClick={() => {
                            handleClickLikeIcon(message, 1);
                          }}
                        >
                          {message.likeStatus === 1 ? zanBrightIcon('#3463FC') : zanDarkIcon('#999999')}
                        </span>
                        <span></span>
                        <span
                          onClick={() => {
                            handleClickLikeIcon(message, 2);
                          }}
                        >
                          {message.likeStatus === 2 ? zanBrightIcon('#F22417') : zanDarkIcon('#999999')}
                        </span>
                      </LikeButContainer>
                    ) : (
                      ''
                    )}
                  </AgentContent>
                )}
              </AgentContentWrapper>
              {message.list?.length > 0 ? (
                <AgentList $device={device} $chatmessagecolor={chatConfig.chatMessageColor}>
                  {message.list.map((item, index1) => {
                    return (
                      <ListItem
                        $device={device}
                        key={index1 + 1000}
                        onClick={() => {
                          handleClickButton(item, index);
                        }}
                        $chatservicecolor={chatConfig.chatServiceColor}
                        $chatmessagecolor={chatConfig.chatMessageColor}
                      >
                        {item.name}
                        <ButtonArrow />
                      </ListItem>
                    );
                  })}
                </AgentList>
              ) : (
                ''
              )}
              {/* <span
                className="messageTime"
                style={{
                  marginLeft: device == 'mobile' ? '40px' : '32px',
                  marginTop: device == 'mobile' ? '-3px' : '-7px',
                  // textAlign: 'right',
                }}
              >
                {message.time}
              </span> */}
            </div>
          </CSSTransition>
        ) : (
          <div>
            <AgentInfoMobile $device={device}>
              <img
                src="https://d1362bz2rn3chi.cloudfront.net/resources/message-loading.gif"
                style={{ height: 50, width: 'auto' }}
              />
            </AgentInfoMobile>
          </div>
        )}
      </ChatMessageAgentWrapper>
    );
  }

  /**
   * connect坐席消息
   * @param message
   * @param index
   */
  function agentMessage(message, index) {
    let avatar = localStorage.getItem('imChatAvatar');
    if (avatar) {
      avatar = JSON.parse(avatar);
    }
    let avatarUrl = avatar?.find((item) => item.uid === message.uid)?.avatar;

    return (
      <CSSTransition in={true} appear={true} timeout={300} classNames="message" key={index}>
        <div className="messageDiv">
          <ChatMessageAgentWrapper>
            <AgentInfo $device={device}>
              {avatarUrl ? (
                <img style={{ borderRadius: 50 }} src={avatarUrl} alt="" />
              ) : (
                agent(chatConfig.chatThemeColor)
              )}
              {/*{agent(chatConfig.chatThemeColor)}*/}
              <span>{message.displayName}</span>
              {/* <span className="messageTime" style={{ marginLeft: '5px' }}>
                {message.time}
              </span> */}
            </AgentInfo>

            <AgentContentWrapper $device={device}>
              {message.contentType === 'image' ? (
                <ContentImage
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                >
                  <Image src={message.content} preview={imagePreview} />
                </ContentImage>
              ) : message.contentType === 'video' ? (
                <ContentVideo
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                >
                  <video
                    src={message.content}
                    controls
                    style={{ width: '100%' }}
                    controlsList="nodownload"
                    playsInline
                  ></video>
                </ContentVideo>
              ) : message.contentType === 'link' ? (
                <AgentContent
                  $agentFontColor={chatConfig.agentFontColor}
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                >
                  <a href={message.content}>{message.fileName}</a>
                </AgentContent>
              ) : (
                <AgentContent
                  $agentFontColor={chatConfig.agentFontColor}
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                >
                  <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown>
                </AgentContent>
              )}
            </AgentContentWrapper>
            {message.extra && message.extra.referenceMessage && message.extra.referenceMessage.referenceContent && (
              <AgentContentWrapper $device={device} style={{ marginTop: '-5px' }}>
                {message.extra.referenceMessage.referenceContentType === 'text' ? (
                  <MessageQuote>
                    {message.extra.referenceMessage.referenceReplyPerson +
                      message.extra.referenceMessage.referenceReplyPerson !=
                    ''
                      ? ':'
                      : ''}
                    {message.extra.referenceMessage.referenceContent}
                  </MessageQuote>
                ) : message.extra.referenceMessage.referenceContentType === 'image' ? (
                  <MessageQuote>
                    <span style={{ whiteSpace: 'nowrap' }}>{message.extra.referenceMessage.referenceReplyPerson}:</span>
                    <Image
                      src={
                        message.extra.referenceMessage.referenceContentFile ||
                        message.extra.referenceMessage.referenceContent
                      }
                      style={{ width: '100px' }}
                      alt=""
                      preview={imagePreview}
                    />
                  </MessageQuote>
                ) : (
                  <MessageQuote>
                    {message.extra.referenceMessage.referenceContent == chatConfig.isRecallMsg
                      ? ''
                      : message.extra.referenceMessage.referenceReplyPerson +
                        (message.extra.referenceMessage.referenceReplyPerson != '' ? ':' : '')}
                    <a href={message.extra.referenceMessage.referenceContent}>
                      {message.extra.referenceMessage.referenceContent}
                    </a>
                  </MessageQuote>
                )}
              </AgentContentWrapper>
            )}
          </ChatMessageAgentWrapper>
        </div>
      </CSSTransition>
    );
  }

  /**
   * 客户消息
   * @param message
   * @param index
   */
  function customerMessage(message, index) {
    let showEndCustomerName = chatConfig.showEndCustomerName;
    return (
      <ChatMessageCustomerWrapper key={index}>
        <CustomerInfo $device={device}>
          {showEndCustomerName && <span>{message.displayName}</span>}
          {/*<img src={customer} alt="" />*/}
          <img src={chatConfig.chatUserIcon || customer} alt="" />
        </CustomerInfo>
        <CustomerContentWrapper $device={device}>
          {(message.contentType === 'image' || message.contentType === 'video' || message.contentType === 'link') &&
          message.uploadStatus !== 'none' ? (
            message.uploadStatus === 'active' ? (
              <UploadContainer key={index}>
                <LeftWrapper
                  $themecolor={chatConfig.chatThemeColor}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  onClick={handleCancelUpload}
                >
                  <img src={close} alt="" />
                </LeftWrapper>
                <RightWrapper>
                  <Progress
                    type="circle"
                    percent={message.uploadProgress}
                    status={message.uploadStatus}
                    strokeColor={chatConfig.chatThemeColor}
                    size={80}
                  />
                  <FileUploading>{message.fileName}</FileUploading>
                </RightWrapper>
              </UploadContainer>
            ) : (
              <UploadContainer key={index}>
                <RightWrapper>
                  <Progress
                    type="circle"
                    percent={message.uploadProgress}
                    status={message.uploadStatus}
                    strokeColor={chatConfig.chatThemeColor}
                    size={80}
                  />
                  <FileUploading>{message.fileName}</FileUploading>
                </RightWrapper>
              </UploadContainer>
            )
          ) : message.contentType === 'image' ? (
            <ContentImage
              $chatservicecolor={chatConfig.chatServiceColor}
              $chatmessagecolor={chatConfig.chatMessageColor}
            >
              <Image src={message.content} preview={imagePreview} />
            </ContentImage>
          ) : message.contentType === 'video' ? (
            <ContentVideo
              $chatservicecolor={chatConfig.chatServiceColor}
              $chatmessagecolor={chatConfig.chatMessageColor}
            >
              <video
                src={message.content}
                controls
                style={{ width: '100%' }}
                controlsList="nodownload"
                playsInline
              ></video>
            </ContentVideo>
          ) : message.contentType === 'link' ? (
            <CustomerContent
              $userFontColor={chatConfig.userFontColor}
              $device={device}
              $chatservicecolor={chatConfig.chatServiceColor}
              $chatmessagecolor={chatConfig.chatMessageColor}
              $showEndCustomerName={chatConfig.showEndCustomerName}
            >
              <a href={message.content}>{message.fileName}</a>
            </CustomerContent>
          ) : message.contentType === 'audio' && message.content == '' ? (
            <div>
              <CustomerMessageWarpper>
                <CustomerContent
                  $userFontColor={chatConfig.userFontColor}
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  $showEndCustomerName={chatConfig.showEndCustomerName}
                >
                  <div className="loaderVoice">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                  {/* <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown> */}
                </CustomerContent>
              </CustomerMessageWarpper>
              <CustomerContentFooter>{message.messageStatus}</CustomerContentFooter>
            </div>
          ) : message.duration != undefined &&
            message.duration != null &&
            message.duration.length > 0 &&
            message.content != '' ? (
            <div>
              <CustomerMessageWarpper>
                <CustomerContent
                  $userFontColor={chatConfig.userFontColor}
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  $showEndCustomerName={chatConfig.showEndCustomerName}
                >
                  <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown>
                </CustomerContent>
              </CustomerMessageWarpper>
              <div className="audioFooter">
                <AudioIcon />
                <span>{message.duration || ''}</span>
              </div>
              <CustomerContentFooter>{message.messageStatus}</CustomerContentFooter>
            </div>
          ) : (
            <div>
              {message.duration}
              <CustomerMessageWarpper>
                <CustomerContent
                  $userFontColor={chatConfig.userFontColor}
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  $showEndCustomerName={chatConfig.showEndCustomerName}
                >
                  <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown>
                </CustomerContent>
              </CustomerMessageWarpper>
              <CustomerContentFooter>{message.messageStatus}</CustomerContentFooter>
            </div>
          )}
          {message.channel === 'IM_CHAT' && (
            <div style={{ display: 'inline-block', marginRight: 5 }}>
              {message.messageAckStatus === 'READ' ? <MsgReadedIcon /> : <MsgReadIcon />}
            </div>
          )}
        </CustomerContentWrapper>
        {/* <span
          className="messageTime"
          style={{
            marginRight: device == 'mobile' ? '40px' : '32px',
            marginTop: device == 'mobile' ? '0px' : '-12px',
            textAlign: 'right',
          }}
        >
          {message.time}
        </span> */}
      </ChatMessageCustomerWrapper>
    );
  }

  function LinkRenderer(props) {
    return (
      <a
        href={props.href}
        target={device === 'mobile' ? '_self' : '_blank'}
        rel="noreferrer"
        onClick={() => {
          let obj = {
            from: 'connectNow',
            action: 'click',
            url: props.href,
            name: props.children,
          };
          window.postMessage(JSON.stringify(obj));
        }}
      >
        {props.children}
      </a>
    );
  }

  function ImgRenderer(props) {
    let src = props.src;
    return <Image src={src} preview={imagePreview} />;
  }

  /**
   * 满意度评价
   * @param message
   * @param index
   */
  function evaluationMessage(message, index) {
    let starCount = 5;
    /**
     * 处理选择评分事件
     */
    const handleRateChange = (e) => {
      setShowGif(true);
      setTimeout(() => {
        setShowGif(false);
      }, 1000);
      console.log(showGif, e);
      if (message.disabled) return;
      message.disabled = true;
      message.content = e;
      handleClickRate(e, message);
    };

    return (
      <CSSTransition key={index} in={true} appear={true} timeout={3000} classNames="message">
        <EvaluationDiv>
          <EvaluationLine
            $chatservicecolor={chatConfig.chatServiceColor}
            $chatmessagecolor={chatConfig.chatMessageColor}
          ></EvaluationLine>
          <div style={{ marginBottom: 10, color: '#666', fontSize: 12 }}>
            {chatConfig.satisfactionEvaluationMessage}
          </div>
          <div style={{ position: 'relative' }}>
            <img
              src="https://chat.connectnow.cn/evaluate.1a9bd5a6.gif"
              style={{
                width: 250,
                height: 'auto',
                position: 'absolute',
                top: '-90px',
                right: '-35px',
                zIndex: 99,
                display: showGif ? 'block' : 'none',
              }}
            />

            <Rate
              value={message.content}
              count={starCount}
              disabled={message.disabled}
              allowClear={false}
              allowHalf={false} // 是否可以选择半星
              onChange={handleRateChange}
              style={{ fontSize: 30 }}
            />
          </div>
        </EvaluationDiv>
      </CSSTransition>
    );
  }

  function dividerMessage(message, index) {
    return (
      // <Divider plain key={index}>
      //   {message.content}
      // </Divider>
      <div className="divider-message" style={{ fontSize: device == 'mobile' ? '0.8rem' : '0.8rem', margin: '0px 0' }}>
        {message.content}
      </div>
    );
  }
  /**
   * 上传中消息
   * @param message
   * @param index
   */
  function uploadingMessage(message, index) {}

  return (
    <MessageBody ref={messageBodyRef}>
      {messageList.map((message, index) => {
        return messageTypeAnalyzer(message, index);
      })}
    </MessageBody>
  );
};

const zanDarkIcon = (color = '#999999') => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.71632 6H2.35826C1.60822 6 1.0002 6.59695 1.0002 7.33333V12C1.0002 12.7364 1.60822 13.3333 2.35826 13.3333H3.71632C4.46636 13.3333 5.07439 12.7364 5.07439 12V7.33333C5.07439 6.59695 4.46636 6 3.71632 6Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4231 14H7.93386C7.39763 14 6.8734 13.8442 6.42723 13.5521L5.37676 12.8646C5.18786 12.7409 5.07439 12.5328 5.07439 12.3099V6.84371C5.07439 6.72769 5.10523 6.61368 5.16386 6.51295L7.50127 2.49697C7.68035 2.18928 8.00952 2 8.36554 2H8.69275C10.0486 2 10.8573 3.48357 10.1052 4.59117L9.14858 6H12.8415C13.725 6 14.3733 6.81518 14.159 7.65671L13.0581 11.9801C12.7558 13.1672 11.6694 14 10.4231 14Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const zanBrightIcon = (color) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.27409 14H10.4238C11.6701 14 12.7565 13.1672 13.0588 11.9801L14.1597 7.65671C14.374 6.81518 13.7257 6 12.8422 6H9.48881L10.3762 4.50645C11.0364 3.39536 10.22 2 8.90987 2H8.70577C8.34975 2 8.02058 2.18928 7.8415 2.49697L5.50409 6.51295C5.44546 6.61368 5.41462 6.72769 5.41462 6.84371V12.3099C5.41462 12.5328 5.52809 12.7409 5.717 12.8646L6.76746 13.5521C7.21363 13.8442 7.73786 14 8.27409 14Z"
        fill={color}
      />
      <path
        d="M2.6 6H3.4C4.28366 6 5 6.56982 5 7.27273V11.7273C5 12.4302 4.28366 13 3.4 13H2.6C1.71634 13 1 12.4302 1 11.7273V7.27273C1 6.56982 1.71634 6 2.6 6Z"
        fill={color}
      />
    </svg>
  );
};

export default ChatMessageAmazon;
